import { Controller } from "@hotwired/stimulus"

/**
 * Generic controller for Google Sheets export buttons.
 *
 * Wraps an export button and listens for Turbo Stream broadcast updates.
 * When the export job completes and broadcasts a result with a
 * `data-sheets-url` attribute, this controller renders the success link
 * from a server-rendered <template> element, then restores the original
 * export button after a delay.
 *
 * Usage (any SheetsExportable model):
 *   <%= render "v2/reporting/sheets_exports/button",
 *     export_path: ..., exportable_type: ..., exportable_id: ... %>
 */
export default class extends Controller {
  static targets = ["status", "successTemplate"]

  statusTargetConnected(target) {
    // Stash the original button markup on first connect (page load).
    if (!this._originalInnerHTML) {
      this._originalInnerHTML = target.innerHTML
    }

    // Check if the broadcast injected a sheets URL
    const url = target.dataset.sheetsUrl
    if (url && this.hasSuccessTemplateTarget) {
      const template = this.successTemplateTarget
      const clone = template.content.cloneNode(true)

      // Replace placeholder URL in the cloned link
      const link = clone.querySelector("a")
      if (link) {
        link.href = url
      }

      target.innerHTML = ""
      target.appendChild(clone)
      delete target.dataset.sheetsUrl

      // Restore the export button only after the user clicks the link
      const insertedLink = target.querySelector("a")
      if (insertedLink) {
        insertedLink.addEventListener("click", () => {
          setTimeout(() => this.#restore(), 3000)
        }, { once: true })
      }
    }
  }

  #restore() {
    if (this._originalInnerHTML && this.hasStatusTarget) {
      const target = this.statusTarget
      target.innerHTML = this._originalInnerHTML
      delete target.dataset.sheetsUrl
    }
  }
}
